import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureAndStoreUtmParams, getGaCampaignParams } from '@/utils/utm';

const ALLOWED_PATHS = ['/login', '/register', '/forgot-password'];

export const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Always capture and store UTM query params if present in URL
    captureAndStoreUtmParams(location.search);

    // Only run tracking in production
    if (import.meta.env.VITE_ENVIRONMENT !== 'production') return;

    const path = location.pathname.replace(/\/$/, '') || '/';
    const isAllowed = ALLOWED_PATHS.includes(path);

    const GA_ID = 'G-95YPKD0QQL';
    const AW_ID = 'AW-18118147529';

    if (isAllowed) {
      // Enable tracking for allowed pages
      (window as any)[`ga-disable-${GA_ID}`] = false;
      (window as any)[`ga-disable-${AW_ID}`] = false;

      // Check if script is already injected
      if (!document.getElementById('ga-script')) {
        const script1 = document.createElement('script');
        script1.id = 'ga-script';
        script1.async = true;
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.id = 'aw-script';
        script2.async = true;
        script2.src = `https://www.googletagmanager.com/gtag/js?id=${AW_ID}`;
        document.head.appendChild(script2);

        (window as any).dataLayer = (window as any).dataLayer || [];
        function gtag(..._args: any[]) {
          (window as any).dataLayer.push(arguments);
        }
        (window as any).gtag = gtag;

        gtag('js', new Date());

        // Disable automatic page views to prevent SPA auto-tracking
        gtag('config', GA_ID, { send_page_view: false, cookie_domain: 'auto' });
        gtag('config', AW_ID, { send_page_view: false });
      }

      // Manually send page view with UTM campaign context for this allowed page
      if ((window as any).gtag) {
        const campaignData = getGaCampaignParams();
        (window as any).gtag('event', 'page_view', {
          page_path: path,
          page_location: window.location.href,
          ...campaignData,
        });
      }
    } else {
      // Strictly disable tracking for all other pages
      (window as any)[`ga-disable-${GA_ID}`] = true;
      (window as any)[`ga-disable-${AW_ID}`] = true;
    }
  }, [location.pathname, location.search]);

  return null;
};
